import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import RenunciaReceitaService from '../../../../services/renunciaReceita';
import { Link } from 'react-router-dom';
import '../../../../styles/diario.scss';
import Exportar from '../../../../components/shared/export'



const FormBusca = (props) => {
    const [nome, setNome] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [setor, setSetor] = useState("");
    const [dataIn, setDataIn] = useState("");
    const [dataFt, setDataFt] = useState("");


    const busca = async (query) => {
        if (query == "") {
            await props.fetchRenuncias()
            setNome("")
            setCnpj("")
            setSetor("")
            setDataIn("")
            setDataFt("")
        } else {
            var response = await RenunciaReceitaService.buscar(query)
            if (response.data.length >= 1) {
                props.setRenuncias(response.data)
                props.setVazio(false)
                setNome("")
                setCnpj("")
                setSetor("")
                setDataIn("")
                setDataFt("")
            } else {
                props.setVazio(true)
                setNome("")
                setCnpj("")
                setSetor("")
                setDataIn("")
                setDataFt("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (nome) prepQuery = prepQuery + `&nome=${encodeURI(nome)}`;
        if (cnpj) prepQuery = prepQuery + `&cnpj=${cnpj}`;
        if (setor) prepQuery = prepQuery + `&setor=${encodeURI(setor)}`;
        if (dataIn) prepQuery = prepQuery + `&dataIn=${dataIn}`;
        if (dataFt) prepQuery = prepQuery + `&dataFt=${dataFt}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="cnpj">
                                <FloatingLabel
                                    label="CNPJ"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="cnpj"
                                        value={cnpj}
                                        onChange={e => setCnpj(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="setor">
                                <FloatingLabel
                                    label="Setor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="setor"
                                        value={setor}
                                        onChange={e => setSetor(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="dataInicial">
                                <FloatingLabel
                                    label="Data Inicial"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataIn"
                                        value={dataIn}
                                        onChange={e => setDataIn(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="dataFinal">
                                <FloatingLabel
                                    label="Data Final"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataFt"
                                        value={dataFt}
                                        onChange={e => setDataFt(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/renuncias'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Row xs={1}>
                        <Col xs={12}>
                            <Exportar data={props.renuncias} nome={"Renuncias"} />
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
